<template>
    <div v-if='resource' ><h2></h2>
        <component :is='resourceComponent' :resource='resource'></component>

        <div v-if='resource.related && resource.related.length > 0'>

            <h2>Related</h2>

            <transition-group name="list" tag='div' class='resourceTiles'>
                <component :is='componentType(related)' v-for='related in relatedItems' :resource='related' :key='related.id'></component>
            </transition-group> 
        </div>
    </div>
</template>

<script>
import PdfViewer from '../components/PdfViewer'
import YouTubeViewer from '../components/YouTubeViewer'
import YouTubeTile from '../components/YouTubeTile'
import PdfTile from '../components/PdfTile'
import PageTile from '../components/PageTile'
import ContentTile from '../components/ContentTile'
import ContentViewer from '../components/ContentViewer'
import EmbedTile from '../components/EmbedTile'
import EmbedViewer from '../components/EmbedViewer'
import _ from 'lodash'
import axios from 'axios'

let types = {
    'Page': 'page-tile',
    'PDF': 'pdf-tile',
    'YouTube': 'youtube-tile',
    'Content': 'content-tile',
    'Embed': 'embed-tile'
}

let viewers = {
    'PDF': 'pdf-viewer',
    'YouTube': 'youtube-viewer',
    'Content': 'content-viewer',
    'Embed': 'embed-viewer'
}

export default {
    name: 'resource',
    props: ['slug'],
    data() {
        return {
            resource: {}
        }
    },
    computed: {
        relatedItems() {
            return _.filter(this.resource.related, x=>x.id != this.resource.id);
        },
        resourceComponent() {
            return viewers[this.resource.type];
        },

    },
    methods: {
        refresh() {
            let query = JSON.stringify({ "id": this.slug });
            axios.get(`${this.$api}/resource/search?query=${query}`).then(result => {
                this.resource = result.data;

                console.log('refreshing');
                this.$emit('updateHead', this.resource);
            });

            if (this.resource.type == 'Page') {
                window.location.href = this.resource.url;
            }
        },
        componentType(resource) {
            return types[resource.type];
        },
    },
    watch: {
        '$route': function() {
            if (this.$route.params.resource) {
                this.resource = this.$route.params.resource;
                this.$emit('updateHead', this.resource);
            }

            this.refresh();
        }
    },
    created() {
        if (this.$route.params.resource) {
            this.resource = this.$route.params.resource;
            this.$emit('updateHead', this.resource);
        } else {
            this.refresh();
        }
    },
    components: {
        'pdf-viewer': PdfViewer,
        'youtube-viewer': YouTubeViewer,
        'page-tile': PageTile,
        'pdf-tile': PdfTile,
        'youtube-tile': YouTubeTile,
        'content-tile': ContentTile,
        'content-viewer': ContentViewer,
        'embed-tile': EmbedTile,
        'embed-viewer': EmbedViewer
    },
    head: {
        meta() {
            if (!_.isEmpty(this.resource)) {
                return [
                    { property: 'og:title', content: this.resource.title },
                    { property: 'og:image', content: this.resource.image.url }
                ]
            }
        }
    }
}
</script>